import { PageResponse, PageRequest } from '..';



export class HandleOperationInfoPageResponse extends PageResponse {
    content: HandleOperationInfo[];
}

export class HandleOperationInfoPageRequest extends PageRequest {
    projectId?: string;
    event?: string;
}

export class HandleOperationInfo {
    operationId: number;
    sourceId: number;
    actionType: string;
    targetProductId: string;
    operationType: string;
    objectType: string;
    wantedAccess: string[];
    wantedAccessValue: number;
    sessionCount: number;
    handleSourceInfo: HandleSourceInfo;
    modifyDate?: any;
    comment?: string;
    reviewer?: string;
    projectName?: string
}

export class HandleSourceInfo {
    sourceId: number;
    actionType: number;
    checksum: string;
    name: string;
    readableName: string;
}

export class UpdateOperationInfoRequest {
    constructor(public actionType: string, public comment: string) { }
}

